import { render, staticRenderFns } from "./temporaryWorkForm.vue?vue&type=template&id=afbacb40&"
import script from "./temporaryWorkForm.vue?vue&type=script&lang=js&"
export * from "./temporaryWorkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports